"use client";
import React, { useEffect, useState } from "react";
import styles from "./UnifiedLoginUser.module.css";
import { Modal, Button } from "react-bootstrap";
import PhoneForm from "./PhoneForm/PhoneForm";
import { XCircle } from "lucide-react";
import Loading from "./Loading/Loading";

interface ModalProps {
  isOpen: boolean;
  onClose: () => void;
}

const UnifiedLoginUser: React.FC<ModalProps> = ({ isOpen, onClose }) => {
  const [isMobile, setIsMobile] = useState(false);
  const [resetStep, setResetStep] = useState(false);
  const [showLoadingModal, setShowLoadingModal] = useState(false);
  const [loadingData, setLoadingData] = useState({
    tokenDetails: null,
    userStatus: null,
  });

  useEffect(() => {
    if (isOpen) {
      setResetStep(true);
    }
  }, [isOpen]);

  useEffect(() => {
    if (typeof window !== "undefined") {
      const handleResize = () => {
        setIsMobile(window.innerWidth <= 767);
      };

      handleResize();
      window.addEventListener("resize", handleResize);
      return () => window.removeEventListener("resize", handleResize);
    }
  }, []);

  const handleOtpSuccess = (tokenDetails: any, userStatus: any) => {
    setLoadingData({ tokenDetails, userStatus });
    onClose();
    setShowLoadingModal(true);
  };

  return (
    <>
      <Modal
        show={isOpen}
        onHide={onClose}
        centered
        size="lg"
        dialogClassName={styles.customModalDialog}
        contentClassName={styles.modalContent}
        backdrop="static"
      >
        <div className={styles.mainContainer}>
          <Button
            variant="link"
            onClick={onClose}
            className="position-absolute"
            style={{
              top: 10,
              right: 5,
              fontSize: 20,
              zIndex: 1000,
              color: "#000",
            }}
          >
            <XCircle />
          </Button>

          <div className={styles.ImageContainer}>
            <img
              src={
                isMobile ? "/assets/mobileImage.png" : "/assets/loginImage.png"
              }
              alt="loginImage"
              title="loginImage"
              fetchPriority="high"
            />

            <div className={styles.bottomContainer}>
              <div className={styles.imageContent}>
                <p className={styles.topText}>
                  Transform Your Career with Seamless Learning!
                </p>
                <div className={styles.topDetails}>
                  <div className={styles.details}>
                    <div className={styles.numbers}>
                      <h4 className={styles.num}>25+ Years </h4>
                      <span className={styles.text}>of excellence</span>
                    </div>
                    <div className={styles.numbers}>
                      <h4 className={styles.num}>300,000+ </h4>
                      <span className={styles.text}>Alumni</span>
                    </div>
                  </div>
                  <div className={styles.details}>
                    <div className={styles.numbers}>
                      <h4 className={styles.num}>180+ </h4>
                      <span className={styles.text}>Countries</span>
                    </div>
                    <div className={styles.numbers}>
                      <h4 className={styles.num}>78+ </h4>
                      <span className={styles.text}>NPS</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className={styles.formContainer}>
            <PhoneForm
              resetStep={resetStep}
              setResetStep={setResetStep}
              onHide={onClose}
              onOtpSuccess={handleOtpSuccess}
            />
          </div>
        </div>
      </Modal>
      <Loading
        isOpen={showLoadingModal}
        userStatus={loadingData.userStatus}
        tokenDetails={loadingData.tokenDetails}
      />
    </>
  );
};

export default UnifiedLoginUser;
